<div *ngIf="hasPrizes$ | async else noprizes">
    <img class="box" [src]="iconsBoxOpen" alt="treasure box" />
</div>

<ng-template #noprizes>
    <div class="item" fxLayout="column" fxLayoutAlign="start center" *ngIf="loginInfo$ | async as loginInfo">
        <div class="vip-avatar" *ngIf="loginInfo.userRole else regularAvatar">
            <div class="vip-img-content" [ngStyle]="{'background': loginInfo.levelConfig.background || 'var(--image-border)'}">
              <img class="vip-player-img" [src]="avatar$ | async" alt="vip player" />
              <div class="role" [ngStyle]="{'background': loginInfo.levelConfig.background}" *ngIf="loginInfo.levelConfig.background && loginInfo.levelConfig.background !== 'var(--image-border)'" i18n>vip</div>
            </div>
            <img class="vip-leef" [src]="loginInfo.levelConfig.leaf" *ngIf="loginInfo.levelConfig.leaf" alt="vip leaf" >
        </div>
        <ng-template #regularAvatar>
          <div class="thumbnail">
              <img class="avatar" [src]="avatar$ | async" alt="player avatar" />
          </div>
        </ng-template>
        <div class="name" i18n>loyalty hub</div>
    </div>
</ng-template>
